(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["video-sections"] && !Shopify.designMode) return;
  try {
    
class CommunityVideoPlayer {
  constructor() {
    this.init();
  }

  init() {
    const playButton = document.querySelector('.play-button');
    const container = document.querySelector('.video-player-container');

    if (playButton && container) {
      playButton.addEventListener('click', (e) => {
        e.stopPropagation();
        const videoUrl = playButton.getAttribute('data-video-url');
        const videoType = playButton.getAttribute('data-video-type');
        
        if (!videoUrl || videoUrl === '') {
          console.log('No video URL provided');
          return;
        }
        
        if (videoType === 'external') {
          this.loadExternalVideo(container, videoUrl);
        } else if (videoType === 'upload') {
          this.loadUploadedVideo(container, videoUrl);
        }
      });
    }
  }

  getYouTubeId(url) {
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    return (match && match[2].length === 11) ? match[2] : null;
  }

  getVimeoId(url) {
    const regExp = /(?:vimeo)\.com.*?(?:[/])([0-9]+)/;
    const match = url.match(regExp);
    return match && match[1] ? match[1] : null;
  }

  loadExternalVideo(container, url) {
    const youtubeId = this.getYouTubeId(url);
    const vimeoId = this.getVimeoId(url);
    let iframeSrc = '';

    if (youtubeId) {
      iframeSrc = `https://www.youtube.com/embed/${youtubeId}?autoplay=1&rel=0`;
    } else if (vimeoId) {
      iframeSrc = `https://player.vimeo.com/video/${vimeoId}?autoplay=1`;
    } else {
      console.error('Unsupported video URL');
      return;
    }

    const iframe = document.createElement('iframe');
    iframe.src = iframeSrc;
    iframe.classList.add('video-iframe');
    iframe.setAttribute('allow', 'autoplay; fullscreen');
    iframe.setAttribute('allowfullscreen', '');

    container.innerHTML = '';
    container.appendChild(iframe);
  }

  loadUploadedVideo(container, url) {
    const video = document.createElement('video');
    video.src = url;
    video.classList.add('native-video');
    video.setAttribute('controls', '');
    video.setAttribute('autoplay', '');
    video.setAttribute('playsinline', '');

    container.innerHTML = '';
    container.appendChild(video);
    
    // Attempt to play
    video.play().catch(error => {
      console.log('Autoplay prevented:', error);
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new CommunityVideoPlayer();
});

  } catch(e) { console.error(e); }
})();
})();
